module.exports = __webpack_public_path__ + "static/media/circle.245569c2.png";